import { SvgIconComponent } from "angular-svg-icon";

import { ChangeDetectionStrategy, Component, computed, input } from "@angular/core";
import { RouterLink } from "@angular/router";

import { HealthStatus } from "../../../apis/stats/rest/models/health-status";
import { StatusToIconPipe } from "../../../helpers/statusiconpipe/statusiconpipe";
import { phraseDetailPath } from "../../../pages/subscription-detail/subscription-detail-redirection";
import { EMPTY_HEALTH } from "../../models/HealthIndicator";
import { ServiceTags } from "../../subscriptions-list/service-tags/service-tags";
import { ServiceIcon } from "../service-icon/service-icon";

export interface ServiceTitleBlockViewModel {
  ipGateway?: boolean;
  product: {
    type: string;
    tag: string;
  };
  subscriptionId: string;
}

@Component({
  selector: "service-title-block",
  templateUrl: "service-title-block.html",
  styles: [":host { display: flex; gap: 16px; }"],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [RouterLink, SvgIconComponent, StatusToIconPipe, ServiceIcon, ServiceTags],
})
export class ServiceTitleBlock {
  /* TODO Reimplement so isAccessible is calculated here */
  public isAccessible = input<boolean>(false);
  public healthStatus = input<HealthStatus>(EMPTY_HEALTH.status);
  public service = input.required<ServiceTitleBlockViewModel>();
  /* TODO Pass on tags from sap-tile and port-tile */
  public tags = input<string[]>([]);
  public title = input.required<string>();
  public firewallEnabled = input<boolean>(false);

  protected icon = computed(() => (this.service().ipGateway ? "ip" : this.service().product.type.toLowerCase()));

  protected routerLink = computed(() =>
    phraseDetailPath(this.service().product.type, this.service().product.tag, this.service().subscriptionId),
  );
}
